import React, { useEffect, useState } from 'react'
import { Col, Grid, Row } from "react-bootstrap"
import axios from 'axios'

import getServerURL from '../../../../functions/getServerURL'
import LoadingAnimation from '../../../../reuseable-components/LoadingAnimation'
import { handleErrorFetchingData } from "../../../../functions/errorHandling"
import List from "./List"
import FilterSidebar from "./FilterSidebar"
import PaginationButtons from "../../../../reuseable-components/PaginationButtons"
import QMSHelpFooter from '../QMSHelpFooter'
import '../style.css'


export default function Trainings() {
  // STATE
  const [trainings, setTrainings] = useState([])
  const [fetchingTrainings, setFetchingTrainings] = useState(false)

  const [currentPage, setCurrentPage] = useState(1)
  const [numberOfPages, setNumberOfPages] = useState(0)
  const entriesPerPage = 10
  
  const [sortTrainingsBy, setSortTrainingsBy] = useState("due_date")
  const [trainingFilters, setTrainingFilters] = useState({
    searchTerm: "",
    showMyTrainings: true,
    notCompleted: false,
    pastDue: false,
  })
  
  // EFFECTS
  useEffect(() => {
    getTrainings(1)
  }, [])

  // REQUESTS
  const getTrainings = (page = 1, sortBy = null, filters = null) => {
    setFetchingTrainings(true)
    setCurrentPage(page)

    sortBy = sortBy || sortTrainingsBy
    filters = filters || {
      search_term: trainingFilters.searchTerm,
      show_my_trainings: trainingFilters.showMyTrainings,
      not_completed: trainingFilters.notCompleted,
      past_due: trainingFilters.pastDue
    }

    axios.get(`${getServerURL()}trainings/`, {
      headers: { "Authorization": `Bearer ${localStorage.getItem("token")}` },
      params: {
        "is_published": true,
        "is_active": true,
        sort_by: sortBy,
        filters,
        "limit": entriesPerPage,
        "offset": entriesPerPage * (page - 1)
      }
    }).then(response => {
      setTrainings(response.data.results)
      setNumberOfPages(Math.ceil(response.data.count / entriesPerPage))
    }).catch(error => {
      handleErrorFetchingData(error)
    }).finally(() => {
      setFetchingTrainings(false)
    })
  }


  // FUNCTIONS
  const handleSortTrainingsBy = (sortBy) => {
    setSortTrainingsBy(sortBy)
    getTrainings(1, sortBy)
  }

  const handleSearchSubmit = () => {
    getTrainings(1)
  }

  const handleFilterChange = (filterType, value) => {
    const updatedFilters = {
      ...trainingFilters,
      [filterType]: value
    }
    setTrainingFilters(updatedFilters)

    if (filterType !== 'searchTerm') {
      const filters = {
        search_term: updatedFilters.searchTerm,
        show_my_trainings: updatedFilters.showMyTrainings,
        not_completed: updatedFilters.notCompleted,
        past_due: updatedFilters.pastDue
      }
      getTrainings(1, sortTrainingsBy, filters)
    }
  }


  // RENDER
  return (
    <div id="Trainings">
      <div>
        <Grid>
          <Row>
            <Col xs={12} md={3}>
              <FilterSidebar
                sortTrainingsBy={ sortTrainingsBy }
                handleSortTrainingsBy={ handleSortTrainingsBy }
                trainingFilters={ trainingFilters }
                handleFilterChange={ handleFilterChange }
                handleSearchSubmit={ handleSearchSubmit }
              />
            </Col>
            <Col xs={12} sm={12} md={9} lg={9}>
              { numberOfPages > 1 &&
                <center>
                  <PaginationButtons
                    onClick={ getTrainings }
                    numberOfPages={ numberOfPages }
                    currentPage={ currentPage }
                    trainingFilters={ trainingFilters }
                    buttonsPerPage={ 5 }
                    disabled={ fetchingTrainings }
                  />
                </center>
              }
              { fetchingTrainings ?
                <LoadingAnimation />
              :
                <List trainings={ trainings } />
              }
            </Col>
          </Row>
        </Grid>
      </div>
      <br />
      <br />
      <br />
      <QMSHelpFooter/>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/routes/qms-training/QMSTraining/Trainings/index.js